import { useInfiniteQuery } from '@tanstack/react-query';

import type { Car } from '@/api/cars/types';
import { client } from '@/api/common';

type Variables = {
  tripId: number;
  startTime: string;
  endTime: string;
  text?: string;
};

type SubstituableCarsPage = {
  data: Car[];
  meta: {
    page: number;
    totalPages: number;
    totalCount: number;
  };
};

const fetchSubstituableCars = async ({
  pageParam,
  variables,
}: {
  pageParam: number;
  variables: Variables;
}) => {
  try {
    let params: Record<string, any> = {
      trip_id: variables.tripId,
      page: pageParam,
      start_time: variables.startTime,
      end_time: variables.endTime,
    };

    if (variables.text) {
      params.text = variables.text;
    }

    const response = await client.get(
      'v2/internal/partners/cars/substituable',
      {
        params: { ...params },
      }
    );

    return response.data;
  } catch (error) {
    console.error('fetchSubstituableCars error:', error);
    throw error;
  }
};

export const useSubstituableCars = (variables: Variables) => {
  return useInfiniteQuery({
    queryKey: ['internal/partners/cars/substituable', variables],
    queryFn: ({ pageParam = 1 }) =>
      fetchSubstituableCars({
        pageParam,
        variables,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage: SubstituableCarsPage) => {
      if (lastPage.meta.page >= lastPage.meta.totalPages) {
        return undefined;
      }
      return lastPage.meta.page + 1;
    },
    enabled:
      variables.startTime !== undefined && variables.endTime !== undefined,
  });
};
